export const navigation = [
  {
    text: "Home",
    icon: "fad fa-home",
    path: "/home",
    id: "abcd",
  },
  {
    text: "Catalog",
    icon: "fad fa-book-open",
    items: [
      {
        text: "Classification",
        path: "/catalog/classification",
        icon: "fad fa-mortar-pestle",
      },
      {
        text: "Category",
        path: "/catalog/category",
        icon: "fad fa-boxes",
      },
      {
        text: "Field",
        path: "/catalog/field",
        icon: "fad fa-line-columns",
      },
      {
        text: "Activity",
        path: "/catalog/activity",
        icon: "fad fa-tools",
      },
      {
        text: "Rating",
        path: "/catalog/rating",
        icon: "fad fa-star",
      },
      {
        text: "Project",
        path: "/catalog/project",
        icon: "fad fa-project-diagram",
      },
    ],
  },
  {
    text: "Data",
    icon: "fad fa-database",
    items: [
      {
        text: "Asset",
        path: "/data/register",
        icon: "fad fa-cabinet-filing",
      },
      {
        text: "Strategy",
        icon: "fad fa-chess-knight",
        path: "/data/strategy",
      },
      {
        text: "Cost",
        icon: "fad fa-dollar-sign",
        path: "/data/cost",
      },
      {
        text: "Geospatial",
        path: "/data/geo",
        icon: "fad fa-map-marked-alt",
      },
      {
        text: "File",
        path: "/data/file",
        icon: "fad fa-file",
      },
    ],
  },
  {
    text: "Analysis",
    icon: "fad fa-microscope",
    visible: true,
    items: [
      {
        text: "Manage",
        path: "/analysis/manage",
        icon: "fad fa-digging",
      },
      {
        text: "Plan",
        path: "/analysis/plan",
        icon: "fad fa-analytics",
      },
    ],
  },
  {
    text: "Tools",
    icon: "fad fa-tools",
    items: [
      {
        text: "Budget",
        icon: "fad fa-sack-dollar",
        path: "/tools/budget",
      },
      {
        text: "Project",
        path: "/tools/project",
        icon: "fad fa-project-diagram",
      },
      {
        text: "Smoothing",
        icon: "fad fa-chart-area",
        path: "/tools/smoothing",
      },
    ],
  },
  {
    text: "Finance",
    icon: "fad fa-cash-register",
    items: [
      {
        text: "Lookup",
        path: "/finance/lookup",
        icon: "fad fa-caret-square-down",
      },
      {
        text: "Input",
        icon: "fad fa-keyboard",
        path: "/finance/input",
      },
      {
        text: "Output",
        icon: "fad fa-chart-bar",
        path: "/finance/output",
      },
    ],
  },
  {
    text: "Report",
    icon: "fad fa-table",
    visible: true,
    items: [
      {
        text: "Query",
        path: "/report/query",
        icon: "fad fa-table",
      },
      {
        text: "QaQc",
        path: "/report/qaqc",
        icon: "fad fa-user-hard-hat",
      },
    ],
  },
  {
    text: "Konnect",
    icon: "fad fa-link",
    visible: true,
    items: [
      {
        text: "Input",
        icon: "fad fa-keyboard",
        path: "/connect/input",
      },
      {
        text: "Output",
        icon: "fad fa-chart-bar",
        path: "/connect/output",
      },
    ],
  },
  {
    text: "Kollect",
    icon: "fad fa-tablet",
    visible: true,
    items: [
      {
        text: "User",
        icon: "fad fa-users",
        path: "/collect",
      },
    ],
  },
  {
    text: "Admin",
    icon: "fad fa-users-crown",
    items: [
      {
        text: "Access",
        icon: "fad fa-user-lock",
        path: "/admin/access",
      },
      {
        text: "Settings",
        icon: "fad fa-cog",
        path: "/admin/setting",
      },

      {
        text: "Audit Logs",
        icon: "fad fa-book-open",
        path: "/admin/audit",
      },
    ],
  },
];
